import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';
import { useContributionModal } from '../context/ContributionModalContext';

const ContributionModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useContributionModal();

  const hasValidDate = data.date && data.date >= data.lastOperationDate;

  const buttonEnabledScriptureView = data.scriptureView && hasValidDate;
  const buttonEnabledDataView = !data.scriptureView && data.totalAmount > 0;

  const buttonText = data.scriptureView ? t('Next') : t('SaveContribution');

  return (
    <>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-lg btn-primary"
          onClick={actions.handleSaveContribution}
          disabled={!buttonEnabledDataView && !buttonEnabledScriptureView}
        >
          {buttonText}
        </button>
      </Modal.Footer>
    </>
  );
};

export default ContributionModalFooter;
